<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            :color="statusColor"
            small
          >{{ form.Status }}</v-chip>
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-if="form.HRRejectReason"
                  v-model="form.HRRejectReason"
                  label="人資退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.ManagerRejectReason"
                  v-model="form.ManagerRejectReason"
                  label="主管拒絕原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.AgentRejectReason"
                  v-model="form.AgentRejectReason"
                  label="代理人拒絕原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="categoryOptions"
                  item-text="Name"
                  item-value="Name"
                  label="假別"
                  readonly
                  v-model="form.Category"
                  :rules="formRules.Category"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.Reason"
                  rows="1"
                  auto-grow
                  label="原因"
                  readonly
                  :rules="formRules.Reason"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="代理人"
                  readonly
                  v-model="form.AgentID"
                  :rules="formRules.AgentID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="formattedBegin"
                  label="開始時間"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="formattedEnd"
                  label="結束時間"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="managerSettingDays">
                <v-text-field
                  v-if="managerSettingDays"
                  :value="managerSettingDays"
                  label="主管設置補休扣除天數"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="shouldShowApplierLeftDays">
                <v-text-field
                  :value="applierLeftDays"
                  label="剩餘可用補休天數"
                  readonly
                ></v-text-field>
              </v-col>
              <!-- <span v-show="form.Category=='補休'">將扣除{{leaveDays}}天補休</span> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          v-if="isSubmitEnabled||isSignEnabled"
          color="white darken-1"
          depressed
          outlined
          text
          @click="reject"
        >拒絕</v-btn>
        <v-btn
          v-if="isSubmitEnabled||isSignEnabled"
          color="white darken-1"
          depressed
          outlined
          text
          @click="pass"
        >同意</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {
      Begin: null,
      End: null,
    },
    defaultForm: {
      Name: "",
      Begin: null,
      End: null,
    },
    categoryOptions: [
      { Name: "事假" },
      { Name: "病假" },
      { Name: "生理假" },
      { Name: "特休" },
      { Name: "補休" },
      { Name: "曠職" },
      { Name: "其他" }
    ]
  }),
  computed: {
    formRules() {
      return {
        Category: [v => !!v || "請輸入名稱"],
        Reason: [v => !!v || "請輸入原因"],
        AgentID: [v => !!v || "請選擇代理人"],
        Begin: [v => !!v || "請輸入開始時間"],
        End: [v => !!v || "請輸入結束時間"]
      };
    },
    formTitle() {
      return "假單";
    },
    statusColor() {
      if (this.form.Status == "代理人拒絕" || this.form.Status == "主管拒絕")
        return "red";
      if (
        this.form.Status == "代理人確認中" ||
        this.form.Status == "主管確認中" ||
        this.form.Status == "人資審核中"
      )
        return "green";
      if (this.form.Status == "通過") return "primary";
      return "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.leaveForm.list.findIndex(o => o.ID == this.id);
    },
    userOptions() {
      return this.users.map(o => {
        return { ID: o.ID, Name: o.Profile.Name };
      });
    },
    isSubmitEnabled() {
      return (
        this.form.Status == "代理人確認中" && this.me.ID == this.form.AgentID
      );
    },
    isSignEnabled() {
      return (
        (this.form.Status == "主管確認中" &&
          this.myLevel == 10 &&
          this.form.DepartmentID == this.myDepartment.ID) ||
        (this.form.Status == "代理人確認中" &&
          this.myLevel == 10 &&
          this.form.DepartmentID == this.myDepartment.ID &&
          this.form.AgentID == this.me.ID) ||
        (this.form.Status == "人資審核中" &&
          this.myLevel == 100)
      );
    },
    formattedBegin() {
      return this.form.Begin ? moment(this.form.Begin).format("LLL") : "";
    },
    formattedEnd() {
      return this.form.End ? moment(this.form.End).format("LLL") : "";
    },
    // leaveDays () {
    //   if (!this.form.Begin) return 0
    //   if (!this.form.End) return 0
    //   let begin = moment(this.form.Begin)
    //   let end = moment(this.form.End)
    //   if (begin.isSame(end, "date")) {
    //     var duration = moment.duration(begin.diff(end));
    //     var hours = duration.asHours();
    //     if (hours==9)hours=8
    //     return Math.abs(hours/8)
    //   }
    //   // 1.
    //   var 第一天下班時間 = moment(begin).set({hour:18,minute:0,second:0,millisecond:0})
    //   var firstDayHours = Math.abs(moment.duration(第一天下班時間.diff(begin)).asHours())
    //   if (firstDayHours==9)firstDayHours=8

    //   var 最後一天上班時間 = moment(end).set({hour:9,minute:0,second:0,millisecond:0})
    //   var lasatDayHours = Math.abs(moment.duration(end.diff(最後一天上班時間)).asHours())
    //   if (lasatDayHours==9)lasatDayHours=8

    //   var allDays = Math.abs(end.diff(begin, 'days')) - 1
    //   if (allDays<0)allDays=0

    //   return (firstDayHours+lasatDayHours)/8+allDays
    // },
    shouldShowApplierLeftDays() {
      return this.form.Category == '補休' && ['主管確認中', '人資審核中', '人資退回'].includes(this.form.Status)
    },
    applierLeftHours () {
      return this.$store.state.compensatoryTime.list.filter(o=>o.UserID === this.form.CreatedBy).reduce((sum,o)=>sum+((o.Status=='通過' || o.LeaveFormID > 0)?o.Hours : 0), 0)
    },
    applierLeftDays() {
      return this.applierLeftHours/8
    },
    managerSettingHours() {
      if (!['人資審核中','通過','人資退回'].includes(this.form.Status)) return null
      return this.form.Hours
    },
    managerSettingDays() {
      return this.managerSettingHours ? this.managerSettingHours/8 : null
    },
    ...mapGetters([
      "users",
      "userPositions",
      "userDepartments",
      "me",
      "myLevel",
      "myDepartment"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    reject() {
      var reason = prompt("請輸入退回原因");
      if (!reason) return alert("請輸入退回原因");
      let rejectReasonKey;
      if (this.myLevel == 1) rejectReasonKey = 'AgentRejectReason'
      if (this.myLevel == 10) rejectReasonKey = 'ManagerRejectReason'
      if (this.myLevel == 100) rejectReasonKey = 'HRRejectReason'
      let payload = {
        ID: this.form.ID
      };
      payload[rejectReasonKey] = reason;
      // payload.Hours = this.leaveDays*8

      let promise;
      let newStatus;
      // let payload;

      if (this.isSignEnabled && this.form.Status == "人資審核中") {
        newStatus = '人資退回'
        promise = this.$services.leaveForm.HRReject(this, payload)
      } else if (this.isSignEnabled) {
        newStatus = '主管拒絕'
        promise = this.$services.leaveForm.rejectLeave(this, payload)
      } else {
        newStatus = '代理人拒絕'
        promise = this.$services.leaveForm.rejectToBeAgent(this, payload)
      }

      this.isLoading = true;
      promise.then(res => {
          this.$set(
            this.$store.state.leaveForm.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.leaveForm.list[this.editingIdx],
            rejectReasonKey,
            reason
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'leaveForm', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    pass() {
      this.isLoading = true;
      var hours = 0
      if (this.isSignEnabled && this.form.Category == '補休' && this.myLevel==10) {
        let hoursResult = window.prompt('請輸入扣除的補休天數')
        if (!hoursResult) {
          this.isLoading = false;
          return alert('請輸入天數!')
        }
        hours = parseInt(hoursResult)*8
      }

      let promise;
      let newStatus;
      // let payload;

      if (this.isSignEnabled && this.form.Status == "人資審核中") {
        newStatus = '通過'
        promise = this.$services.leaveForm.HRSign(this, this.form.ID)
      } else if (this.isSignEnabled) {
        newStatus = '人資審核中'
        promise = this.$services.leaveForm.sign(this, this.form.ID, hours)
      } else {
        newStatus = '主管確認中'
        promise = this.$services.leaveForm.submit(this, this.form.ID)
      }

      promise.then(res => {
          this.$set(
            this.$store.state.leaveForm.list[this.editingIdx],
            "Status",
            newStatus
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'leaveForm', this.form.ID)
          let shouldRefetchCompensatoryTimes = newStatus == '通過' && this.form.Category == '補休'
          if (shouldRefetchCompensatoryTimes) {
            this.$store.state.compensatoryTime.isFetched = false
            return this.$services.compensatoryTime.prepareData(this).then(this.close)
          }
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.form = JSON.parse(JSON.stringify(this.defaultForm));

      if (!this.value) return;
      if (this.id < 0 || this.editingIdx < 0) {
        this.isLoading = false;
        alert("發生異常：無法找到編輯物件");
        return;
      }
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      this.form = JSON.parse(
        JSON.stringify(this.$store.state.leaveForm.list[this.editingIdx])
      );
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.leaveForm.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>